import { render } from "./DocumentationOverview.vue?vue&type=template&id=277ccd08&scoped=true"
import script from "./DocumentationOverview.vue?vue&type=script&lang=js"
export * from "./DocumentationOverview.vue?vue&type=script&lang=js"

import "./DocumentationOverview.vue?vue&type=style&index=0&id=277ccd08&scoped=true&lang=scss"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277ccd08"]])

export default __exports__